import React from 'react';
import { Card, Row, Col, Statistic } from 'antd';
import { UserOutlined, TeamOutlined, CalendarOutlined } from '@ant-design/icons';

const EmployeeStats = ({ stats }) => {
  return (
    <Row gutter={16} style={{ marginBottom: '24px' }}>
      <Col span={6}>
        <Card>
          <Statistic
            title="员工总数"
            value={stats.total}
            prefix={<UserOutlined />}
          />
        </Card>
      </Col>
      <Col span={6}>
        <Card>
          <Statistic
            title="试用期员工"
            value={stats.statusStats?.find(s => s.status === 'probation')?.count || 0}
            prefix={<CalendarOutlined />}
          />
        </Card>
      </Col>
      <Col span={6}>
        <Card>
          <Statistic
            title="正式员工"
            value={stats.statusStats?.find(s => s.status === 'regular')?.count || 0}
            prefix={<TeamOutlined />}
          />
        </Card>
      </Col>
      <Col span={6}>
        <Card>
          <Statistic
            title="部门数量"
            value={stats.deptStats?.length || 0}
            prefix={<TeamOutlined />}
          />
        </Card>
      </Col>
    </Row>
  );
};

export default EmployeeStats;
